import { useMemo } from 'react';

import { useDefaultFindingStore, useFindingStore } from '@/store';

import { mergeDefaultAndCommonFindings } from '../util';

export function useDefaultAndCommonFindings() {
  const defaultFindings = useDefaultFindingStore((state) => state.defaultFindings);
  const findings = useFindingStore((state) => state.findings);

  const value = useMemo(
    () => mergeDefaultAndCommonFindings(defaultFindings, findings),
    [defaultFindings, findings],
  );

  return value;
}
